import styled from 'styled-components';
import { useSelectContext } from './select-context';

const Option = ({ children, value }) => {
  const { onOptionSelect } = useSelectContext();
  return <S.Option onClick={() => onOptionSelect(value)}>{children}</S.Option>;
};

const S = {
  Option: styled.div`
    padding: 0.75rem 1rem;
    cursor: pointer;

    &:hover {
      background: rgba(0, 0, 0, 0.09);
    }
  `,
};

export default Option;
